
    <div class="container container-extra mt-50" *ngIf="data && groupGoalData">

        <app-back-nav class="mb-20" [linkText]="'GROUP_GOAL.BACK_TO_GOALS' | translate" [link]="getBackLink()"></app-back-nav>

        <section class="page-title">
            <h1>{{ 'GROUP_GOAL.TEXT_BASED_TEAM_GOALS' | translate }}</h1>
            <div class="review-period-info" *ngIf="data">{{ data.goalPeriod.reviewPeriod.name }} | {{ data.goalPeriod.reviewPeriod.startDate | datePlain }} - {{ data.goalPeriod.reviewPeriod.endDate | datePlain }}</div>
        </section>

           <mat-card class="frame main-card p-24">
            <mat-card-content>

                <div *ngFor="let groupGoal of data.goalPeriod.groupGoals">
                    <app-group-goal-edit 
                        [data]="groupGoalData"
                        [groupGoal]="groupGoal"
                        [goalPeriod]="data.goalPeriod"
                        (delete)="itemDeleted($event)"
                    ></app-group-goal-edit>

                    <div class="gradient-separator"></div>
                </div>

            </mat-card-content>

            <div class="action-button-panel">
                <div class="bottom-actions">
                    <button mat-flat-button (click)="showInformation()" class="lg-button button-bg-alt1 button-info">{{ 'GROUP_GOAL.INFORMATION' | translate }}</button>
                    <button mat-flat-button color="primary" class="lg-button new-button" [disabled]="!allowAddNew()" (click)="addNew()">{{ 'GROUP_GOAL.NEW_TEAM_GOAL' | translate }}</button>
                </div>
                <div class="footer-buttons">
                    <div class="footer-left-buttons">
                        <button mat-flat-button (click)="showInformation()" class="lg-button button-bg-alt1 button-info">{{ 'GROUP_GOAL.INFORMATION' | translate }}</button>
                    </div>
                    <div class="footer-right-buttons">
                        <button mat-flat-button color="primary" class="lg-button" (click)="onOk()">{{ 'GENERAL.OK' | translate }}</button>
                        <a mat-flat-button color="accent" class="lg-button" [routerLink]="getBackLink()">{{ 'GENERAL.CANCEL' | translate }}</a>
                    </div>
                </div>
            </div>
        </mat-card>
        
</div>
